function MessageIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 19.0096C9.42502 19.0096 8.88335 18.718 8.50002 18.2096L7.25002 16.543C7.22502 16.5096 7.12502 16.468 7.08335 16.4596H6.66669C3.19169 16.4596 1.04169 15.518 1.04169 10.8346V6.66797C1.04169 2.98464 2.98335 1.04297 6.66669 1.04297H13.3334C17.0167 1.04297 18.9584 2.98464 18.9584 6.66797V10.8346C18.9584 14.518 17.0167 16.4596 13.3334 16.4596H12.9167C12.85 16.4596 12.7917 16.493 12.75 16.543L11.5 18.2096C11.1167 18.718 10.575 19.0096 10 19.0096ZM6.66669 2.29297C3.68335 2.29297 2.29169 3.68464 2.29169 6.66797V10.8346C2.29169 14.6013 3.58335 15.2096 6.66669 15.2096H7.08335C7.50835 15.2096 7.99169 15.4513 8.25002 15.793L9.50002 17.4596C9.79169 17.843 10.2084 17.843 10.5 17.4596L11.75 15.793C12.025 15.4263 12.4584 15.2096 12.9167 15.2096H13.3334C16.3167 15.2096 17.7084 13.818 17.7084 10.8346V6.66797C17.7084 3.68464 16.3167 2.29297 13.3334 2.29297H6.66669Z"
        fill="#00A653"
      />
      <path
        d="M9.99999 9.9987C9.53332 9.9987 9.16666 9.6237 9.16666 9.16536C9.16666 8.70703 9.54166 8.33203 9.99999 8.33203C10.4583 8.33203 10.8333 8.70703 10.8333 9.16536C10.8333 9.6237 10.4667 9.9987 9.99999 9.9987Z"
        fill="#00A653"
      />
      <path
        d="M13.3333 9.9987C12.8667 9.9987 12.5 9.6237 12.5 9.16536C12.5 8.70703 12.875 8.33203 13.3333 8.33203C13.7917 8.33203 14.1667 8.70703 14.1667 9.16536C14.1667 9.6237 13.8 9.9987 13.3333 9.9987Z"
        fill="#00A653"
      />
      <path
        d="M6.66668 9.9987C6.20001 9.9987 5.83334 9.6237 5.83334 9.16536C5.83334 8.70703 6.20834 8.33203 6.66668 8.33203C7.12501 8.33203 7.50001 8.70703 7.50001 9.16536C7.50001 9.6237 7.13334 9.9987 6.66668 9.9987Z"
        fill="#00A653"
      />
    </svg>
  );
}

export default MessageIcon;
